<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="请输入搜索内容"
        v-model.trim="searchName"
        class="handle-input mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="getIsManager"
        >设置管理员</el-button
      >
      <el-button type="primary" size="small" @click="addData"
        >新增操作员</el-button
      >
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column label="账号" align="center" prop="username">
      </el-table-column>
      <el-table-column label="操作员姓名" align="center" prop="realname">
      </el-table-column>
      <el-table-column
        label="角色"
        align="center"
        prop="role_name"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="权限" align="center">
        <template #default="scope">
          <el-popover
            title="权限"
            width="400px"
            placement="right"
            trigger="click"
            :ref="`popover-${scope.$index}`"
          >
            <div class="role-permission">{{ scope.row.permission_name }}</div>
            <template #reference>
              <div class="permission_name">{{ scope.row.permission_name }}</div>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建日期" width="180px">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.create_time, "yyyy-MM-dd hh:mm") }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280" align="center">
        <template #default="scope">
          <el-button
            type="success"
            size="mini"
            v-if="scope.row.username != 'admin'"
            @click="getUserRole(scope.row)"
            >角色权限设置</el-button
          >
          <el-button
            type="danger"
            size="mini"
            v-if="scope.row.username != 'admin'"
            @click="delData(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>

    <!-- 设置管理员 -->
    <el-dialog
      title="设置管理员"
      v-model="setUp_admin"
      width="700px"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="administrator">
        <div class="administrator_wrap">
          <div class="left">
            <h2>成员列表</h2>
            <ul>
              <li v-for="(item, index) in commonUser" :key="item.id">
                {{ item.realname }}
                <span>
                  <i
                    class="el-icon-circle-plus-outline"
                    @click="addIsManager(item, index)"
                  ></i>
                </span>
              </li>
            </ul>
          </div>
          <div class="right">
            <h2>管理员列表</h2>
            <ul>
              <li v-for="(item, index) in isManagerData" :key="item.id">
                {{ item.realname }}

                <span>
                  <i
                    v-if="index > 0"
                    class="el-icon-remove-outline"
                    @click="delIsManager(item, index)"
                  ></i>
                  <span v-else>超级管理员</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" size="small" @click="setIsManager"
            >确定</el-button
          >
          <el-button type="danger" size="small" @click="setUp_admin = false"
            >取消</el-button
          >
        </span>
      </template>
    </el-dialog>

    <!-- 新增操作员 -->
    <el-dialog
      title="新增操作员"
      v-model="add_admin"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
      @close="close"
    >
      <div class="administrator">
        <el-form
          :model="form"
          ref="form"
          size="small"
          :rules="rules"
          label-width="110px"
          inline
        >
          <div>
            <el-form-item label="账号：" prop="username">
              <el-input
                class="input"
                placeholder="字母、数字"
                v-model.trim="form.username"
                show-word-limit
                maxlength="20"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="操作员姓名：" prop="realname">
              <el-input
                class="input"
                placeholder="操作员姓名"
                v-model.trim="form.realname"
                show-word-limit
                maxlength="10"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="角色权限：" prop="roleId">
              <div class="role">
                <el-switch
                  v-model="form.roleOpen"
                  :active-value="1"
                  :inactive-value="0"
                ></el-switch>
                <el-select
                  v-if="form.roleOpen"
                  v-model="form.roleId"
                  placeholder="角色权限"
                  multiple
                  collapse-tags
                >
                  <el-option
                    v-for="item in roleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                    <div
                      class="roleName"
                      :class="{ active: form.roleId.indexOf(item.id) >= 0 }"
                    >
                      <li>
                        <span>{{ item.name }}</span>
                      </li>
                    </div>
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="设置密码：" prop="password">
              <el-input
                class="input"
                placeholder="6-20位字母、数字"
                v-model.trim="form.password"
                show-password
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="确认密码：" prop="confirm">
              <el-input
                class="input"
                placeholder="6-20位字母、数字"
                v-model.trim="form.confirm"
                show-password
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" size="small" @click="save">确定</el-button>
          <el-button type="danger" size="small" @click="add_admin = false"
            >取消</el-button
          >
        </span>
      </template>
    </el-dialog>

    <!-- 设置人员角色 -->
    <el-dialog
      width="600px"
      title="选择角色"
      v-model="role_dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="close"
      destroy-on-close
    >
      <div class="administrator">
        <el-form
          :model="roleForm"
          ref="roleForm"
          size="small"
          :rules="roleRules"
          label-width="110px"
          inline
        >
          <div>
            <el-form-item prop="role">
              <el-checkbox-group v-model="roleForm.role">
                <el-checkbox
                  :label="item.id"
                  v-for="item in roleList"
                  :key="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" size="small" @click="setUserRole"
            >确定</el-button
          >
          <el-button type="danger" size="small" @click="role_dialog = false"
            >取消</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      searchName: "",
      setUp_admin: false,
      add_admin: false,
      role_dialog: false,
      itemData: {},
      isManagerData: [],
      commonUser: [],
      form: {
        username: "",
        realname: "",
        roleOpen: 0,
        roleId: "",
        password: "",
        confirm: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入账号", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "只能包含数字或字母",
            trigger: "blur",
          },
        ],
        realname: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        roleId: [
          {
            required: true,
            validator: (rule, value, callback) => {
              this.checkRole(rule, value, callback);
            },
            trigger: "change",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,
            message: "必须包含字母和数字最少6位最多20位",
            trigger: "blur",
          },
        ],
        confirm: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          {
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,
            message: "必须包含字母和数字最少6位最多20位",
            trigger: "blur",
          },
          {
            required: true,
            validator: (rule, value, callback) => {
              this.checkConfirmVal(rule, value, callback);
            },
            trigger: ["blur"],
          },
        ],
      },
      roleForm: {
        role: [],
      },
      roleRules: {},
      roleList: [],
    };
  },
  methods: {
    checkConfirmVal(rule, value, callback) {
      if (value != this.form.password) {
        return callback(new Error("确认密码不正确"));
      } else {
        callback();
      }
    },
    checkRole(rule, value, callback) {
      if (this.form.roleOpen) {
        if (this.form.roleId.length === 0) {
          return callback(new Error("请选择角色"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    async getData(page = 1) {
      if (this.searchName.length > 30) {
        this.$message.warning("搜索内容最多输入30个字");
        return;
      }
      const params = {
        name: this.searchName,
        currentPage: page,
        pageSize: 20,
      };
      try {
        this.$loading.start();
        const res = await this.$api.setUp.getPersonnel(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    async getIsManager() {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.setUp.getIsManager();
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.isManagerData = [];
            this.commonUser = [];
            res.data.forEach((item) => {
              if (item.is_manager) {
                this.isManagerData.push(item);
              } else {
                this.commonUser.push(item);
              }
            });
            this.setUp_admin = true;
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    addIsManager(item, index) {
      item.is_manager = 1;
      this.commonUser.splice(index, 1);
      this.isManagerData.push({ ...item });
    },
    delIsManager(item, index) {
      item.is_manager = 0;
      this.isManagerData.splice(index, 1);
      this.commonUser.push({ ...item });
    },
    async setIsManager() {
      if (!this.loading) {
        try {
          let list = this.commonUser.concat(this.isManagerData);
          list = list.map((item) => {
            return {
              id: item.id,
              isManager: item.is_manager,
            };
          });
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.setUp.setIsManager(list);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.setUp_admin = false;
            this.$message.success("保存成功！");
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    async getRole(params = null) {
      try {
        const res = await this.$api.setUp.getRole(params ? params : "");
        if (res.code === 10200) {
          this.roleList = [];
          this.roleList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {}
    },
    async addData() {
      await this.getRole();
      this.add_admin = true;
    },
    close() {
      this.form = {
        username: "",
        realname: "",
        roleId: [],
        password: "",
        confirm: "",
      };
      this.roleForm = {
        role: [],
      };
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.addOperator();
        } else {
          return false;
        }
      });
    },
    async addOperator() {
      if (!this.loading) {
        try {
          const params = {
            username: this.form.username,
            realname: this.form.realname,
            roleId: this.form.roleOpen ? this.form.roleId.toString() : "",
            password: this.form.password,
          };
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.setUp.addIsManager(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.getData(this.data.current);
            this.add_admin = false;
            this.$message.success("添加成功！");
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    async getUserRole(data) {
      this.itemData = data;
      await this.getRole({ managerUserId: data.id });
      this.roleList.forEach((item) => {
        if (item.value) {
          this.roleForm.role.push(item.id);
        }
      });
      this.role_dialog = true;
    },
    async setUserRole() {
      if (!this.loading) {
        try {
          const params = {
            managerUserId: this.itemData.id,
            roleId: this.roleForm.role.toString(),
          };
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.setUp.setUserRole(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.getData(this.data.current);
            this.$message.success("设置成功！");
            this.role_dialog = false;
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    delData(data) {
      if (!this.loading) {
        this.$confirm("是否确认删除？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            try {
              this.loading = true;
              this.$loading.start();
              const res = await this.$api.setUp.delUser(data.id);
              this.loading = false;
              this.$loading.done();
              if (res.code === 10200) {
                this.getData(this.data.current);
                this.$message.success("删除成功");
              } else {
                this.$message.error(res.msg);
              }
            } catch (error) {
              this.loading = false;
              this.$loading.done();
            }
          })
          .catch(() => {});
      }
    },
  },
  created() {
    this.getData();
  },
  watch: {
    searchName: {
      handler() {
        this.getData();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 200px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;

  .el-select {
    width: 180px;
  }
}

.el-image {
  width: 160px;
  height: 90px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.administrator {
  padding: 0 20px;
  .administrator_wrap {
    display: flex;
    border: 1px solid $--border-color-base;

    & > div {
      flex: 1;
      min-height: 300px;

      &:first-child {
        border-right: 1px solid $--border-color-base;
      }

      h2 {
        height: 40px;
        line-height: 40px;
        font-size: 1rem;
        font-weight: 500;
        text-align: center;
        box-sizing: border-box;
        border-bottom: 1px solid $--border-color-base;
      }

      ul {
        padding: 0 40px;

        li {
          display: flex;
          height: 40px;
          align-items: center;

          & > span {
            margin-left: auto;
            i {
              cursor: pointer;
              font-size: 1.25rem;
              color: $--color-primary;
            }
          }
        }
      }
    }
  }
  .el-switch {
    margin-right: 10px;
  }
  .input,
  .role {
    width: 240px;
  }

  .el-select {
    flex: 1;
  }

  .role {
    height: 32px;
    display: flex;
    align-items: center;
  }
}

.permission_name {
  width: 100%;
  cursor: pointer;
  line-height: 23px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.role-permission {
  line-height: 30px;
}

.roleName {
  padding-right: 20px;
  li {
    max-width: 280px;
    box-sizing: border-box;
    line-height: 32px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    text-overflow: -o-ellipsis-lastline;
    white-space: break-spaces;
  }
}

.active::after {
  top: 0;
  right: 20px;
  content: "";
  font-size: 12px;
  font-weight: 700;
  position: absolute;
  font-family: element-icons;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>